import { EStreamTradeDTO } from '../../types/estream/eStreamTrade';
import { InstrumentStoreItemFundamentals } from '../../types/estream/instrumentStoreItem';

export const mapFundamentals = (item: EStreamTradeDTO): Partial<InstrumentStoreItemFundamentals> => {
  return {
    marketCap: item?.data?.MKTCAP,
    eps_ttm: item?.data?.TTMBEPSXCL,
    p_bv: item?.data?.PRICE2BK,
    p_e_ttm: item?.data?.PEBEXCLXOR,
    p_s_ttm: item?.data?.TTMPR2REV,
    dividend: item?.data?.DIVIDEND,
    dividendYield: item?.data?.YIELD,
    dividendYield5YAvg: item?.data?.YLD5YAVG,
    ebitda_ttm: item?.data?.TTMEBITD,
    roe_ttm: item?.data?.TTMROEPCT,
    roa_ttm: item?.data?.TTMROAPCT,
  };
};
